import { getFirestore } from 'redux-firestore';

export const useContentStateRef = ({userId, cardId}) => {
  return getFirestore()
    .doc(`/users/${userId}/cards/${cardId}/states/default`)
};
